export async function fetcher(url: string, { token, ...args }): Promise<any> {
    const response = await fetch(url, {
        method: 'GET',
        headers: { Authorization: `Bearer ${token}` },
        ...args,
    });

    if (!response.ok) {
        throw new Error(`Fetch failed: ${response.statusText}`);
    }

    if (response.headers.get('Content-Type')?.includes('application/json')) {
        return response.json()
    }

    return response.text()
}
